import { TRANSFER_STATUSES } from "../../hooks/api/useGetCalculationById";
import { CheckIcon } from "@mantine/core";
import {
  QrCodeIcon,
  EnvelopeIcon,
  BriefcaseIcon,
  ArrowPathIcon,
  ExclamationTriangleIcon,
  NoSymbolIcon,
} from "@heroicons/react/24/solid";

export const determineStatusColor = (transferStatus: TRANSFER_STATUSES) => {
  switch (transferStatus) {
    case TRANSFER_STATUSES.TRANSFER_ONGOING:
    case TRANSFER_STATUSES.AWAIT_SIGN_EMPLOYER:
      return "var(--wallet-color-neutrals-yellow-300)";
    case TRANSFER_STATUSES.NEED_COMPLETION:
      return "#FED0A5";
    case TRANSFER_STATUSES.TRANSFER_ABORTED:
      return "var(--wallet-color-sambla-red-shade-400)";
    case TRANSFER_STATUSES.TRANSFER_COMPLETE:
      return "#BFEBCD";
    default:
      return "var(--wallet-color-neutrals-gray-100)";
  }
};

export const determineStatusIcon = (
  transferStatus: TRANSFER_STATUSES,
  isDigital: boolean,
) => {
  switch (transferStatus) {
    case TRANSFER_STATUSES.NEW:
      return isDigital ? (
        <QrCodeIcon height="20px" width="20px" />
      ) : (
        <EnvelopeIcon height="20px" width="20px" />
      );

    case TRANSFER_STATUSES.AWAIT_SIGN_DIGITAL:
      return <QrCodeIcon height="20px" width="20px" />;
    case TRANSFER_STATUSES.AWAIT_SIGN_POST:
      return <EnvelopeIcon height="20px" width="20px" />;
    case TRANSFER_STATUSES.AWAIT_SIGN_EMPLOYER:
      return <BriefcaseIcon height="20px" width="20px" />;
    case TRANSFER_STATUSES.TRANSFER_ONGOING:
      return <ArrowPathIcon height="20px" width="20px" />;
    case TRANSFER_STATUSES.NEED_COMPLETION:
      return <ExclamationTriangleIcon height="20px" width="20px" />;
    case TRANSFER_STATUSES.TRANSFER_ABORTED:
      return <NoSymbolIcon height="20px" width="20px" />;
    case TRANSFER_STATUSES.TRANSFER_COMPLETE:
      return <CheckIcon height="20px" width="20px" />;
    default:
      return null;
  }
};

export const determineStatusMessage = (transferStatus: TRANSFER_STATUSES) => {
  switch (transferStatus) {
    case TRANSFER_STATUSES.NEW:
      return "Vi har ännu inte fått någon status för din försäkring. Så snart vi har inhämtat information kan du se det här.";
    case TRANSFER_STATUSES.AWAIT_SIGN_DIGITAL:
      return "Vi väntar på att du ska signera flyttdokumentet med BankID. När det är klart kommer vi att påbörja flytten av försäkringen till Idun Liv.";
    case TRANSFER_STATUSES.AWAIT_SIGN_POST:
      return "Du kommer att få ett dokument skickat till din adress. Signera dokumentet och skicka tillbaka för att påbörja flytten av din försäkring till Idun Liv.";
    case TRANSFER_STATUSES.AWAIT_SIGN_EMPLOYER:
      return "Vi väntar på att din före detta arbetsgivare (som står som ägare av pensionsförsäkringen) ska godkänna flytten. Du behöver inte göra något, Idun Liv tar hand om processen.";
    case TRANSFER_STATUSES.TRANSFER_ONGOING:
      return "Vi håller på att flytta försäkringen till Idun Liv och håller dig uppdaterad under processen.";
    case TRANSFER_STATUSES.NEED_COMPLETION:
      return "Idun Liv har påbörjat flytten av din försäkring men behöver mer information. Det kan gälla uppgifter från din arbetsgivare, försäkringsbolaget eller dig. Om något saknas från din sida kommer Idun Liv att kontakta dig.";
    case TRANSFER_STATUSES.TRANSFER_ABORTED:
      return "Flytten av försäkringen till Idun Liv har avbrutits. Det kan vara för att ägaren av försäkringen (arbetsgivaren) inte har godkänt flytten eller så har Idun Liv gjort bedömningen att flytten inte kommer att gå igenom.";
    case TRANSFER_STATUSES.TRANSFER_COMPLETE:
      return "Försäkringen är nu flyttad till Idun Liv och du kommer från och med nu kunna följa den i din pensionsöversikt. Du kan läsa mer information i dina dokument, eller kontakta oss vid eventuella funderingar.";
    case TRANSFER_STATUSES.MONITORED:
      return "Försäkringen håller på att flyttas, men det har uppstått en situation som gör att Idun Liv behöver hålla ett extra öga på flytten. Det kan vara så att det saknas information eller att det är något i försäkringen som behöver utredas närmare. Idun Liv kommer att kontakta dig om de behöver mer information eller om det är något du behöver göra.";
    default:
      return null;
  }
};

export const determineStatusTitle = (
  transferStatus: TRANSFER_STATUSES,
  isDigital: boolean,
) => {
  switch (transferStatus) {
    case TRANSFER_STATUSES.NEW:
      return isDigital
        ? "Inväntar digital signatur"
        : "Inväntar signatur via post";
    case TRANSFER_STATUSES.AWAIT_SIGN_DIGITAL:
      return "Inväntar digital signatur";
    case TRANSFER_STATUSES.AWAIT_SIGN_POST:
      return "Inväntar signatur via post";
    case TRANSFER_STATUSES.AWAIT_SIGN_EMPLOYER:
      return "Inväntar arbetsgivare";
    case TRANSFER_STATUSES.TRANSFER_ONGOING:
      return "Flytt pågår";
    case TRANSFER_STATUSES.NEED_COMPLETION:
      return "Komplettering behövs";
    case TRANSFER_STATUSES.TRANSFER_ABORTED:
      return "Flytt avbruten";
    case TRANSFER_STATUSES.TRANSFER_COMPLETE:
      return "Flytt klar";
    default:
      return "Bearbetar";
  }
};
